export default "__VITE_ASSET__yY0q59Zr__"